import {Team} from './types';

export const MockData: Team[] = [
  {id: 20, name: 'Kongsberg'},
  {id: 30, name: 'Askim'},
];
